import React from 'react'
import Utils from '../../../../utils/Utils'

export const ProjectCartaFactura = React.forwardRef((props, ref) => {
  const { getProject } = props

  const created_at = Utils.formatDateTime(new Date(getProject?.created_at))

  return (
    <div ref={ref} style={{ textAlign: 'center', marginLeft: '2rem', marginRight: '2rem' }} className='ticket-modal-quotation'>
      <br></br>
      <p style={{ marginTop: 0 }}>{'SALIDA DE PRODUCTO'}</p>
      <div style={{ textAlign: 'left', display: 'flex', justifyContent: 'space-between' }}>
        <div>
          <p style={{ fontWeight: 'bolder' }}>{`Tienda:`}</p>
          <p style={{ fontWeight: 'bolder' }}>{`No. de Salida:`}</p>
          <p style={{ fontWeight: 'bolder' }}>{`Fecha:`}</p>
          <p style={{ fontWeight: 'bolder' }}>{`Origen/Motivo:`}</p>
          <p style={{ fontWeight: 'bolder' }}>{`Destino/Motivo:`}</p>
          <p style={{ fontWeight: 'bolder' }}>{`Creado Por:`}</p>
        </div>
        <div>
          <p style={{ fontWeight: 'bolder' }}>{getProject?.store.name}</p>
          <p style={{ fontWeight: 'bolder' }}>{`${getProject?.id}`}</p>
          <p style={{ fontWeight: 'bolder' }}>{`${created_at}`}</p>
          <p style={{ fontWeight: 'bolder' }}>{`${getProject.origin_reason ? getProject.origin_reason : '...'}`}</p>
          <p style={{ fontWeight: 'bolder' }}>{`${getProject.destination_reason ? getProject.destination_reason : '...'}`}</p>
          <p style={{ fontWeight: 'bolder' }}>{`${getProject?.creator?.name ? getProject?.creator?.name : ' '}`}</p>
          <p style={{ fontWeight: 'bolder' }}>{``}</p>
        </div>
        <div></div>
        <div></div>
      </div>

      <br></br>
      <table className='ticket-modal-quotation' style={{ width: '-webkit-fill-available' }}>
        <thead style={{ borderBottom: '2px solid rgba(0, 0, 0, 0.65)', borderTop: '2px solid rgba(0, 0, 0, 0.65)' }}>
          <tr>
            <th>{`Código`}</th>
            <th>{`Producto`}</th>
            <th>{`Cantidad`}</th>
          </tr>
        </thead>
        <tbody>
          {getProject?.project_details && getProject?.project_details?.map((data) => (
            <tr key={data.id}>
              <td>{`${data.presentation_id}`}</td>
              <td style={{ display: 'flex', textTransform: 'none' }}>{data?.presentation?.description.substring(0, 40)}</td>
              <td>{`${data.quantity}`}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
});